
// import { load } from "recaptcha-v3";

const FormField = (target) => {

  const method = {

    init: () => {
      method.checkIfFilled();

      target.addEventListener("keyup", method.checkIfFilled);
      target.addEventListener("change", method.checkIfFilled);
    },

    checkIfFilled: () => {
      if (target.value.length > 0) {
        target.parentElement.parentElement.classList.add("fieldset--filled");
      } else {
        target.parentElement.parentElement.classList.remove("fieldset--filled");
      }
    },
  };

  method.init();
};

// TODO
// const FormSubmit = (target) => {

//   const el = {
//     button: target.querySelector(".button"),
//     error: target.querySelector(".contact__error"),
//     form: target,
//     success: target.parentElement.querySelector("h1").nextElementSibling,
//     token: target.querySelector("input[name=token]"),
//   };

//   const method = {

//     init: () => {
//       el.form.addEventListener("submit", method.submitForm);
//     },

//     submitForm: (event) => {
//       event.preventDefault();

//       el.button.setAttribute("disabled", true);
//       el.error.innerHTML = null;

//       load("6LejkKsZAAAAAKDvYhWX17pb0VFC_KbUd0ubP_vx", {
//         autoHideBadge: true,
//       }).then((recaptcha) => {
//         recaptcha.execute("contact").then((token) => {
//           el.token.value = token;

//           const data = new FormData(event.target);
//           const xhr = new XMLHttpRequest();

//           xhr.open("POST", event.target.getAttribute("action"));

//           xhr.onload = () => {
//             if (xhr.status >= 200 && xhr.status < 300) {
//               const serverResponse = xhr.response;
//               const { success, message } = JSON.parse(serverResponse);

//               if (success) {
//                 el.form.classList.add("contact--sent");
//                 el.success.innerHTML = message;
//                 setTimeout(() => {
//                   el.form.classList.add("contact--hidden");
//                 }, 1000);
//               } else {
//                 el.error.innerHTML = `<p>${message}</p>`;
//                 setTimeout(() => {
//                   el.button.removeAttribute("disabled");
//                 }, 500);
//               }
//             }
//           };

//           xhr.send(data);

//         });
//       });
//     },
//   };

//   method.init();
// };

export { FormField };
